import { useTranslation } from "react-i18next";
import BasicDialog from "../../../components/base/BasicDialog";
import { Grid} from "@mui/material";
import DiscountStatusProposalTabs from "./DiscountStatusProposalTabs";

export function SendProposalDialog(props) {
    const { t } = useTranslation();


    return (
        <BasicDialog
            open={true}
            onClose={() => props.onClose()}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("products.submitProposal")}
            maxWidth={"xxl"}
            showDialogActions
            alwaysFullScreen={false}
            contentSx={{ pt: 0 }}
        >
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                rowSpacing={1}
                columnSpacing={2}
            >
                <Grid item xs={12}>
                    <DiscountStatusProposalTabs {...props}/>
                </Grid>
            </Grid>
        </BasicDialog>
    );
}